import { getVendors } from "../../store/AsyncMethods/VendorMethod";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { RESET_SPECIFIC_CATEGORIES } from "../../store/Types/CategoryTypes";
import { useTranslation } from "react-i18next";
import { Dropdown } from "primereact/dropdown";
import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Icons, toast } from "react-toastify";
import { Divider } from "primereact/divider";

import {
  addCurrency,
  getCurrency,
  getEnableCurrency,
  getspecificCurrency,
  updateCurrency,
} from "../../store/AsyncMethods/CurrencyMethod";
import { SelectButton } from "primereact/selectbutton";
import {
  addCustomers,
  getCustomers,
  getspecificCustomer,
  updateCustomer,
} from "../../store/AsyncMethods/CustomerMethod";
import { Calendar } from "primereact/calendar";
import {
  getSales,
  getspecificSale,
  getUnpaidPostedInvoices,
} from "../../store/AsyncMethods/SalesMethod";
import {
  getPurchase,
  getspecificPurchase,
} from "../../store/AsyncMethods/PurchaseMethod";
import {
  addCashReceipt,
  getspecificCashReceipt,
  getCashReceipt,
  getCustomerBalance,
  updateCashReceipt,
  getPendingSalesById,
} from "../../store/AsyncMethods/CashReceiptMethod";
import { useLocation } from "react-router-dom";

export default function AddCashReceipt() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { specificCashReceipt } = useSelector((state) => state.cashReceipts);
  const { customerBalance, pendingSales } = useSelector(
    (state) => state.cashReceipts
  );
  const { allCustomers } = useSelector((state) => state.CustomersReducer);
  const { allVendors } = useSelector((state) => state.VendorReducer);
  const { allCurrency } = useSelector((state) => state.CurrencyReducer);
  const { specificSale } = useSelector((state) => state.SalesReducer);
  const [isDisabled, setIsDisabled] = useState(false);
  const { allSales, unpaidPostedInvoices } = useSelector(
    (state) => state.SalesReducer
  );
  const location = useLocation();
  const { allPurchases } = useSelector((state) => state.PurchaseReducer);
  const { specificPurchase } = useSelector((state) => state.PurchaseReducer);
  const { success, error, user } = useSelector((state) => state.AuthReducer);
  const navigate = useNavigate();
  const { id } = useParams();
  const { specificCustomer } = useSelector((state) => state.CustomersReducer);
  const [selectedTransactionType, setSelectedTransactionType] = useState(1);
  console.log("newone", customerBalance);
  useEffect(() => {
    if (id) {
      dispatch(getspecificCashReceipt(id));
    }
  }, [id]);

  const receiptTypes = [
    { name: t("Cash"), id: 1 },
    { name: t("Return"), id: 2 },
  ];

  const transactionTypes = [
    { name: "Sales", id: 1 },
    { name: "Purchase", id: 2 },
  ];

  const formik = useFormik({
    initialValues: {
      receiptType: 1,
      description: "",
      customer: "",
      balance: 0,
      amount: "",
      total: "",
      paidAmount: 0,
      customerOpeningBalance: 0,
      currency: 5,
      invoice: "",
      posted: 0,
      name: "",
      date: new Date(),
      newRemainingAmount: 0,
      originalRemainingAmount: "",
      type: 1,
      transactionType: 1,
    },
    validationSchema: Yup.object({
      // name: Yup.string().required("Name Required"),
      // balance: Yup.string().required("Balance Required"),
      // receiptType: Yup.string().required("Type Required"),
      // date: Yup.string().required("Transaction Date Required"),
      // amount: Yup.string().required("Amount Required"),
      // // currency: Yup.string().required("Currency Required"),
      // invoice: Yup.string().required("Invoice Required"),
    }),

    onSubmit: async (data) => {
      if (id) {
        dispatch(updateCashReceipt(data, id)).then((success) => {
          if (success) {
            formik.resetForm();
            dispatch(getCashReceipt());
            navigate(
              user?.role_id == 1 ? "/cash-receipt-main" : "/cash-receipt-main"
            );
          }
        });
      } else {
        const submissionData = {
          ...data,
          amount: data.originalRemainingAmount
            ? (
                parseFloat(data.originalRemainingAmount) -
                parseFloat(data.paidAmount)
              ).toString()
            : data.amount,
        };

        dispatch(addCashReceipt(submissionData)).then((success) => {
          if (success) {
            formik.resetForm();
          }
        });
      }
    },
  });

  const filteredCustomers = allCustomers.filter(
    (customer) => customer.debit_allowed === 0
  );

  // Filter invoices that match the selected customer's id
  const filteredInvoices = unpaidPostedInvoices?.filter(
    (invoice) => invoice.customer_id === formik.values.customer
  );

  useEffect(() => {
    console.log(unpaidPostedInvoices);
    console.log(formik.values.customer);
    console.log(filteredInvoices);
  }, [filteredInvoices]);

  useEffect(() => {
    return () => {
      formik.resetForm();
    };
  }, [location.pathname]);

  useEffect(() => {
    if (specificCashReceipt.customer_id || formik.values.customer) {
      dispatch(
        getCustomerBalance(
          specificCashReceipt.customer_id || formik.values.customer
        )
      );
    }
  }, [specificCashReceipt.customer_id, formik.values.customer]);

  useEffect(() => {
    if (specificCashReceipt) {
      formik.setValues({
        ...formik.values,
        description: specificCashReceipt.description || "",
        customer: specificCashReceipt.customer_id || 0,
        // Convert string date to Date object
        date: specificCashReceipt.date
          ? new Date(specificCashReceipt.date)
          : new Date(),
        // Ensure currency_id is a number
        remainingAmount: specificCashReceipt.remain_amount,
        currency: Number(specificCashReceipt.currency_id) || 5,
        total: pendingSales.total_sale_amount || "",
        balance: specificCashReceipt.amount_received || "",
        paidAmount: specificCashReceipt.amount_received || 0,
        invoice: specificCashReceipt.sales_id || 0,
        posted: specificCashReceipt.isPosted || 0,
        name: specificCashReceipt.customer_name || "",
        // balance: specificCashReceipt.customer_balance || "",
      });
      if (specificCashReceipt.posted === 1) {
        setIsDisabled(true);
      }
    }
  }, [specificCashReceipt]);

  useEffect(() => {
    if (formik.values.posted === 1) {
      setIsDisabled(true);
    }
  }, [formik.values.posted]);

  useEffect(() => {
    if (!id) {
      if (formik.values.customer) {
        formik.setFieldValue("invoice", "");
      }
    }
  }, [formik.values.customer]);

  useEffect(() => {
    if (customerBalance) {
      formik.setValues({
        ...formik.values,
        customerOpeningBalance: customerBalance.opening_balance || "",
      });
    }
  }, [customerBalance]);

  useEffect(() => {
    if (specificCustomer) {
      formik.setValues({
        ...formik.values,
        name: specificCustomer.name || "",
      });
    }
  }, [specificCustomer]);

  useEffect(() => {
    if (formik.values.customer)
      dispatch(getspecificCustomer(formik.values.customer));
  }, [formik.values.customer]);

  useEffect(() => {
    dispatch(getCustomers());
    dispatch(getCurrency());
    dispatch(getSales());
  }, []);

  useEffect(() => {
    if (!id) {
      if (formik.values.invoice) {
        if (selectedTransactionType === 1) {
          dispatch(getspecificSale(formik.values.invoice));
          dispatch(getPendingSalesById(formik.values.invoice));
        } else {
          dispatch(getspecificPurchase(formik.values.invoice));
        }
      }
    }
  }, [formik.values.invoice, selectedTransactionType, id]);

  useEffect(() => {
    if (!id) {
      if (specificSale) {
        console.log(specificSale);
        formik.setValues({
          ...formik.values,
          amount: specificSale.remain_amount || "",
          total: pendingSales.total_sale_amount || "",
          originalRemainingAmount: specificSale.remain_amount || "",
          remainingAmount: specificSale.remain_amount || "",
          paidAmount: pendingSales.amount_received || "",
        });
      }
    }
  }, [
    specificSale,
    specificPurchase,
    selectedTransactionType,
    formik.values.invoice,
    pendingSales,
  ]);

  useEffect(() => {
    formik.setFieldValue(
      "remainingAmount",
      formik.values.total - formik.values.paidAmount
    );
  }, [formik.values.balance]);

  const handleBalanceChange = (e) => {
    const newBalance = parseFloat(e.target.value) || 0;
    const currentAmount = parseFloat(formik.values.amount) || 0;
    const newRemainingAmount = currentAmount - newBalance;

    formik.setValues({
      ...formik.values,
      balance: e.target.value,
      remainingAmount: newRemainingAmount,
    });
  };

  useEffect(() => {
    if (specificCustomer && formik.values.customer) {
      formik.setFieldValue("name", specificCustomer.name || "");
    } else {
      formik.setFieldValue("name", "");
    }
  }, [specificCustomer, formik.values.customer]);

  useEffect(() => {
    if (
      formik.values.paidAmount + formik.values.amount ==
      formik.values.total
    ) {
      formik.values.remainingAmount = 0;
    }
  });

  return (
    <div className="mx-4">
      <form onSubmit={formik.handleSubmit}>
        <div className="card shadow-md rounded-lg p-4 mt-3">
          <Divider>
            <span className="text-2xl font-bold p-font-style text-center text-primary mx-1">
              {t("cash_receipt")}
            </span>
          </Divider>

          <div className="px-4 gap-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="receiptType" className="">
                  {t("Receipt Type")}
                </label>

                <Dropdown
                  id="receiptType"
                  name="receiptType"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.receiptType}
                  onChange={formik.handleChange}
                  options={receiptTypes}
                  optionLabel="name"
                  optionValue="id"
                  disabled={isDisabled}
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.receiptType && formik.errors?.receiptType && (
                <div className="p-error">{formik.errors?.receiptType}</div>
              )}
            </div>

            <div className=" ">
              <div className="flex flex-col  gap-2  p-fluid">
                <label htmlFor="date" className="">
                  {t("trans_date")}
                </label>

                <Calendar
                  dateFormat="yy/mm/dd"
                  id="date"
                  onChange={formik.handleChange}
                  className=" w-full calender p-primary-cld-btn"
                  value={formik.values.date}
                  disabled={isDisabled}
                  showIcon
                />
              </div>
              {formik.touched?.date && formik.errors?.date && (
                <div className="p-error">{formik.errors?.date}</div>
              )}
            </div>

            {/* Empty space for visual balance */}
            <div className=""></div>
            <div className=""></div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="customer" className="">
                  {t("Select Customer")}
                </label>

                <Dropdown
                  id="customer"
                  name="customer"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.customer}
                  onChange={formik.handleChange}
                  options={filteredCustomers}
                  disabled={isDisabled}
                  optionLabel="name"
                  optionValue="id"
                  filter
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.customer && formik.errors?.customer && (
                <div className="p-error">{formik.errors?.customer}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="name" className="">
                  {t("customer_name")}
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="name"
                    name="name"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.name && formik.errors?.name && (
                <div className="p-error">{formik.errors?.name}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="customerOpeningBalance" className="">
                  {t("Customer Balance")}
                </label>
                <span className="flex gap-2 w-full">
                  <InputText
                    id="customerOpeningBalance"
                    name="customerOpeningBalance"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.customerOpeningBalance}
                    onChange={formik.handleChange}
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.balance && formik.errors?.balance && (
                <div className="p-error">{formik.errors?.balance}</div>
              )}
            </div>
            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="invoice" className="">
                  {t("Select Invoice")}
                </label>

                <Dropdown
                  id="invoice"
                  name="invoice"
                  className="!w-full text-lg p-primary-input"
                  value={formik.values.invoice}
                  onChange={formik.handleChange}
                  options={filteredInvoices}
                  disabled={isDisabled}
                  optionLabel={(option) =>
                    `(${option.id}) - ${new Date(option.created_at)}`
                  }
                  optionValue="id"
                  filter
                  pt={{
                    root: { className: "w-full" },
                    input: { className: "w-full p-primary-input" },
                    filterIcon: { className: "ml-2" },
                    filterInput: { className: "pl-8" },
                  }}
                />
              </div>
              {formik.touched?.invoice && formik.errors?.invoice && (
                <div className="p-error">{formik.errors?.invoice}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="amount" className="">
                  {t("total_amount")}
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="total_amount"
                    name="total_amount"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.total}
                    onChange={formik.handleChange}
                    disabled
                    placeholder="0"
                  />
                </span>
              </div>
              {formik.touched?.amount && formik.errors?.amount && (
                <div className="p-error">{formik.errors?.amount}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="paidAmount" className="">
                  {t("Paid Amount")}
                </label>
                <span className=" flex gap-2 w-full">
                  <InputText
                    id="paid_amount"
                    name="paid_amount"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.paidAmount}
                    placeholder="0"
                    onChange={formik.handleChange}
                    disabled
                  />
                </span>
              </div>
              {formik.touched?.amount && formik.errors?.amount && (
                <div className="p-error">{formik.errors?.amount}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="balance" className="">
                  {t("Amount")} <span className="text-red">*</span>
                </label>
                <span className="flex gap-2 w-full">
                  <InputText
                    id="balance"
                    name="balance"
                    placeholder="0"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.balance}
                    disabled={isDisabled}
                    onChange={handleBalanceChange}
                  />
                </span>
              </div>
              {formik.touched?.balance && formik.errors?.balance && (
                <div className="p-error">{formik.errors?.balance}</div>
              )}
            </div>

            <div className="">
              <div className="flex flex-col gap-2">
                <label htmlFor="remainingAmount" className="">
                  {t("Remaining Amount")}
                </label>
                <span className="flex gap-2 w-full">
                  <InputText
                    id="remainingAmount"
                    name="remainingAmount"
                    placeholder="0"
                    className="w-full text-lg p-primary-input"
                    value={formik.values.remainingAmount}
                    disabled
                  />
                </span>
              </div>
            </div>
          </div>
        </div>

        {isDisabled ? (
          <div className="mt-8">
            <div className="flex justify-end gap-4">
              <Button
                label={t("GO Back")}
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={() => {}}
              />
            </div>
          </div>
        ) : (
          <div className="mt-8">
            <div className="flex justify-end gap-4">
              <Button
                label={t("cancel")}
                icon="pi pi-times"
                className="p-red-btn"
                type="button"
                onClick={() => {
                  formik.resetForm();
                }}
              />
              <Button
                label={t(id ? "update" : "submit")}
                icon="pi pi-check"
                className="p-secondary-btn"
                type="submit"
              />
              <Button
                label={t("post")}
                icon="pi pi-check"
                className="p-primary-btn"
                type="submit"
                onClick={() => {
                  formik.values.posted = 1;
                }}
              />
            </div>
          </div>
        )}
      </form>
    </div>
  );
}
